import { Button, message, Row, Space, Typography } from "antd";
import { useState } from "react";
import "./ForgotPassword.css";
import FloatingInput from "../../../components/common/float-input/FloatInput";
import { useDispatch, useSelector } from "react-redux";
import { requestPassword } from "../../../store/thunks/authThunk";

const { Text } = Typography;

const ForgotPassword = ({ navigateTo }) => {
  const [email, setEmail] = useState("");
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const { requestStatus, isLoading } = useSelector((state) => state.password);
  const [isResetLinkSent, setIsResetLinkSent] = useState(false);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
    "--label-margin-top": "-6px",
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const dispatch = useDispatch();
  const handleResetPassword = async () => {
    if (!email) {
      message.error("Please enter your email address.");
      return;
    }
    dispatch(requestPassword({ email: email }))
      .then((res) => {
        if (res?.status === 1) {
          setIsResetLinkSent(true);
        } else {
          setIsResetLinkSent(false);
        }
      })
      .catch(() => {
        setIsResetLinkSent(false);
      });
  };

  return (
    <>
      {!isResetLinkSent ? (
        <div className="forgotpassword-container">
          <Space direction="vertical" size={12}>
            <Row justify="center">
              <Text className="forgot-password-h">Forgot Password?</Text>
            </Row>
            <Row>
              <Text className="forgot-password-sh">
                Enter your email, and we’ll send a reset link to get you back on
                track.
              </Text>
            </Row>

            <Row>
              <FloatingInput
                className="billboard-input-feild"
                label={
                  <>
                    {`Email Address`}
                    {star}
                  </>
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleResetPassword();
                  }
                }}
                customStyles={floatingInputStyles}
                onChange={handleChange}
                style={{
                  borderColor:
                    requestStatus === "failed" ? "#D2042D" : "#333333",
                }}
              />
            </Row>
            <Row>
              <Button
                type="primary"
                htmlType="submit"
                className="reset-button billboard-button-2"
                onClick={handleResetPassword}
                loading={isLoading}
              >
                Reset Password
              </Button>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: 40 }}>
              <a
                className="forgot-password"
                onClick={() => navigateTo("login")}
              >
                Back to Login
              </a>
            </Row>
          </Space>
        </div>
      ) : (
        <div className="resetpassword-container">
          <Space direction="vertical" size={12}>
            <Row justify="center">
              <Text className="forgot-password-h">Reset Link Sent!</Text>
            </Row>
            <Row justify="center">
              <Text className="please-check-text">
                We’ve sent a password reset link to&nbsp;
                <span className="highlighted-email">{email}</span>
              </Text>
            </Row>
            <Row justify="center">
              <Text className="please-check-text">
                Please check your inbox and follow the instructions to set a new
                password.
              </Text>
            </Row>

            <Row justify="center" className="try-span-text-row">
              <Text className="try-span-text">
                Didn’t get it? Try Checking your spam folder
              </Text>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: 40 }}>
              <a
                className="forgot-password"
                onClick={() => {
                  setIsResetLinkSent(false);
                }}
              >
                Resend Email
              </a>
            </Row>
          </Space>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
